; (function (inovestor, undefined) {
    // Setup dependencies for this plugin
    // Normally we would add jQuery and knockout but ms-core, which we depend on, already register them so it's useless

    // Create plugin namespace with any desired config variable
    inovestor.ms.stock = inovestor.ms.stock || {};
})(inovestor);


; (function (stock, undefined) {
    // Create plugin namespace with any desired config variable
    stock.shareholders = {
        config: {
            apiRelativeUrl: 'stocks/shareHolders?symbol={symbol}'
        }
    };

})(inovestor.ms.stock);


; (function ($, ko, inovestor, undefined) {
    inovestor.ms.stock.shareholders.viewModels = {};
    inovestor.ms.stock.shareholders.viewModels.holdingsViewModel = function (redirectUrl) {

        var self = this;
        self.holdings = ko.observable();
        self.shareHolders = ko.observableArray();
        self.topShareholders = ko.observable();
        self.requestedSymbol = ko.observable();
        self.resources = ko.observable();
        self.hasError = ko.observable(false);
        self.isInvalidIdentifier = ko.observable(false);
        self.dataNotAvailable = ko.observable(false);
        self.hasValidData = ko.computed(function () {
            return !self.hasError() && !self.isInvalidIdentifier() && self.holdings() != null;
        }, this);
        self.hasShareholders = ko.computed(function () {
            return self.dataNotAvailable() && self.hasValidData()
        }, this);
        self.updateResources = function () {
            // Update main resources
            var currentResource = inovestor.ms.stock.shareholders.resources[inovestor.ms.core.currentLanguage];
            if (inovestor.ms.core.isNullOrUndefined(currentResource))
                currentResource = null;
            self.resources(currentResource);
        };
        self.navigateToResult = function () {
            var url = redirectUrl;
            window.location = inovestor.ms.core.stringFormat(url, {
                symbol: encodeURIComponent(this.symbol),
                category: encodeURIComponent(this.category)
            });
        };

        //Pagination
        self.filter = ko.observable('');
        self.pageSize = ko.observable(10);
        self.pageIndex = ko.observable(0);
        self.previousPage = function () {
            return self.pageIndex(self.pageIndex() - 1)
        };
        self.nextPage = function () {
            return self.pageIndex(self.pageIndex() + 1)
        };
        self.maxPageIndex = ko.dependentObservable(function () {
            return Math.ceil(self.shareHolders().length / this.pageSize()) - 1;
        }, this);
        self.pagedHolders = ko.dependentObservable(function () {
            var size = this.pageSize();
            var start = this.pageIndex() * size;
            return self.shareHolders.slice(start, start + size);
        }, this);
        //End  of Pagination
        self.urlValues = ko.observableArray();
        self.selfUrl = ko.observable();
        self.redirectUrlTarget = ko.observable();
    }

})(inovestor.ms.libRef.jQuery, inovestor.ms.libRef.ko, inovestor);
; (function ($, ko, inovestor, undefined) {

    var pluginName = 'inoMsStockShareholders';

    // Create the plugin constructor
    function Plugin(element, options) {

        this.element = element;
        this._name = pluginName;
        this._defaults = $.fn.inoMsStockShareholders.defaults;
        // Merge options with defaults
        this.options = $.extend({}, this._defaults, options);
        this._viewModel = new inovestor.ms.stock.shareholders.viewModels.holdingsViewModel(this.options.redirectUrl);
        this.topShareholders = 10;
        this._viewModel.topShareholders(this.topShareholders);
        this._cachedTopColors = null;

        // Make sure required variables are set
        if (inovestor.ms.core.isNullOrUndefined(this.options.symbol))
            throw "symbol is required";

        // Call init
        this.init();

    }

    $.extend(Plugin.prototype, {

        // Initialization logic
        init: function () {
            var plugin = this;

            // Setup what plugin needs to do on language change
            inovestor.ms.core.instances.register(this, function () {
                plugin.update();
                plugin.renderCharts();
            });

            // Set target for any redirect option
            if (!inovestor.ms.core.isNullOrUndefined(plugin.options.redirectUrlTarget))
                plugin._viewModel.redirectUrlTarget(plugin.options.redirectUrlTarget);

            // Plugin overrides for template = cacheKey and path are the same
            var fileCacheKey = plugin.options.templatePaths.shareholders;
            var filePath = plugin.options.templatePaths.shareholders;
            // Default behavior (if no template path is set by plugin)
            if (inovestor.ms.core.isEmptyString(fileCacheKey)) {
                var fileName = 'shareholders.html';
                fileCacheKey = pluginName + '.' + fileName;
                filePath = (inovestor.ms.core.isEmptyString(inovestor.ms.core.config.templateRootUrl) ? '' : inovestor.ms.core.config.templateRootUrl) +
                    (inovestor.ms.core.isEmptyString(inovestor.ms.core.config.templateRootUrl) || inovestor.ms.core.config.templateRootUrl.match(/\/$/) != null ? '' : '/') + // check if templateRootUrl ends in slash
                    (this._name + '/' + fileName);
            }

            // Get main template file
            inovestor.ms.core.getTemplate(fileCacheKey, filePath).then(function (template) {
                $(plugin.element).html(template);
                plugin.buildCache();
                plugin.render();
                plugin.bindModel();
                plugin.bindEvents();
            }).then(function () {
                // Call Search
                plugin.search(plugin.options.symbol).always(function () {
                    // When search is completed, trigger onReady event
                    plugin.$element.trigger('ready' + '.' + plugin._name);


                });
            });
        },

        // Remove plugin instance completely
        destroy: function () {
            this.unbindEvents();
            this.$element.removeData();
        },

        // Cache DOM nodes for performance
        buildCache: function () {
            this.$element = $(this.element);
        },

        // Bind events that trigger methods
        bindEvents: function () {
            var plugin = this;
            plugin.$element.on('ready' + '.' + plugin._name, function () {
                var onReady = plugin.options.onReady;
                if (typeof onReady === 'function')
                    onReady.call(plugin.$element);
            });
        },

        // Unbind events that trigger methods
        unbindEvents: function () {
            this.$element.off('.' + this._name);
        },

        // API error handler
        apiErrorHandler: function (apiError) {
            var plugin = this;
            var onError = plugin.options.onError;
            if (typeof onError === 'function') {
                var result = onError.call(inovestor.ms.core.generateError(inovestor.ms.core.errors.apiError, apiError, plugin));
                // If callback returns false, do not execute default behavior
                if (!inovestor.ms.core.isNullOrUndefined(result) && result === false)
                    return;
            }

            plugin._viewModel.hasError(true);
        },

        // Invalid Identifier error handler
        invalidIdentifierHandler: function () {
            var plugin = this;
            var onError = plugin.options.onError;
            if (typeof onError === 'function') {
                var result = onError.call(inovestor.ms.core.generateError(inovestor.ms.core.errors.invalidIdentifier, null, plugin));
                // If callback returns false, do not execute default behavior
                if (!inovestor.ms.core.isNullOrUndefined(result) && result === false)
                    return;
            }

            plugin._viewModel.isInvalidIdentifier(true);
        },

        // Search for a particular fund
        search: function (symbol) {
            var plugin = this;
            plugin._viewModel.requestedSymbol(symbol);



            // Make sure required variables are set
            if (inovestor.ms.core.isNullOrUndefined(symbol))
                throw "symbol is required";

            // Update options
            plugin.options.symbol = symbol;

            // Setup API url with term
            var stockHoldingsUrl = inovestor.ms.core.stringFormat(inovestor.ms.stock.shareholders.config.apiRelativeUrl, { symbol: symbol });

            // Reset relevant Data before calling API
            plugin._viewModel.holdings(null);
            plugin._viewModel.hasError(false);
            plugin._viewModel.isInvalidIdentifier(false);

            // Call API and bind model
            var options = { type: 'GET', contentType: 'application/json', error: function (error) { plugin.apiErrorHandler(error); } };
            return inovestor.ms.core.ajaxApi(stockHoldingsUrl, options).then(function (data) {
                if (!inovestor.ms.core.isNullOrUndefined(data)) {
                    if (data.requestStatus === 'invalidIdentifier')
                        plugin.invalidIdentifierHandler();

                    data.shareHolders = inovestor.ms.core.sortArray(data.shareHolders, false, function (i, b) { return (i.numberOfShares) > (b.numberOfShares); });
                    plugin._viewModel.holdings(data);
                    plugin._viewModel.shareHolders(data.shareHolders);
                    plugin.renderCharts();
                    plugin._legendInTable();
                    plugin._colorify();
                    plugin._setUrlValues();
                }
                if (data.shareHolders.length < 1) {
                    plugin._viewModel.dataNotAvailable(true);
                }
                plugin.update();
            });
        },

        _setUrlValues: function () {
            var plugin = this;
            var selfUrl = null;
            var url = plugin.options.redirectUrl;
            values = [];
            var shareHolders = plugin._viewModel.holdings().shareHolders;
            requestedSymbol = plugin._viewModel.holdings().symbol;
            var l = shareHolders.length;
            for (var u = 0; u < l; u++) {
                if (shareHolders[u].symbol == requestedSymbol) {
                    selfUrl = inovestor.ms.core.stringFormat(url, {
                        symbol: encodeURIComponent(shareHolders[u].symbol),
                        category: encodeURIComponent(shareHolders[u].category)
                    });
                    plugin._viewModel.selfUrl(selfUrl);
                }
                values.push(inovestor.ms.core.stringFormat(url, {
                    symbol: encodeURIComponent(shareHolders[u].symbol),
                    category: encodeURIComponent(shareHolders[u].category)
                }));
            };
            plugin._viewModel.urlValues(values);
        },

        _getPieChartConfig: function () {
            var plugin = this;
            var pieChartConfig = $.extend(true, {}, plugin.options.pieChartConfig);
            return pieChartConfig;
        },

        _getBarChartConfig: function () {
            var plugin = this;
            var barChartConfig = $.extend(true, {}, plugin.options.barChartConfig);
            return barChartConfig;
        },
        // Renders html template and binds model (should be called once)
        render: function () {
            var plugin = this;
            plugin._viewModel.updateResources();
        },

        //Render Charts
        renderCharts: function () {
            var plugin = this;
            plugin._renderBarChart();
            plugin._renderPieChart();
            plugin._legendInTable();
        },

        // Update resources
        update: function () {
            var plugin = this;
            // Update view model resources
            plugin._viewModel.updateResources();
            plugin._viewModel.holdings.valueHasMutated();
            plugin._viewModel.pageIndex.subscribe(function (newValue) {
                if (newValue == 0) {
                    plugin._colorify();
                }
            });

        },

        // Applies knockout bindings to element. (Should be done only once)
        bindModel: function () {
            var plugin = this;
            ko.applyBindings(plugin._viewModel, plugin.element);
        },

        //Pie Chart Rendering 
        _renderPieChart: function () {
            var plugin = this;
            var shareholders = plugin._viewModel.holdings().shareHolders;
            var sharesSum = 0;
            if (plugin._viewModel.hasValidData()) {
                var chartConfig = plugin._getPieChartConfig();
                var pieData = [];
                var pie = plugin.$element.find('.pie-chart');
                var resultsThreshold = 10;
                var resultsToDisplay = shareholders.length > resultsThreshold ? resultsThreshold : shareholders.length;
                var topTenPercent = 0;
                for (var fund = 0; fund < resultsToDisplay; fund++) {
                    topTenPercent += shareholders[fund].shareOutstandingPercent;
                    var percent = shareholders[fund].shareOutstandingPercent;
                    sharesSum += shareholders[fund].numberOfShares;
                    pieData.push({
                        y: percent >= 0 ? percent : percent * -1, // handling of negative data sets
                        formattedY: Highcharts.numberFormat(percent, 2) + ' %',
                        name: inovestor.ms.core.currentLanguage == 'fr' ? shareholders[fund].nameFr : shareholders[fund].nameEn,

                    });

                };
                // Add slice 'other'
                var percent = ((plugin._viewModel.holdings().sharesOutstanding - sharesSum) / plugin._viewModel.holdings().sharesOutstanding) * 100;
                pieData.push({
                    y: percent >= 0 ? percent : percent * -1, // handling of negative data sets
                    formattedY: Highcharts.numberFormat(percent, 2) + ' %',
                    name: inovestor.ms.core.currentLanguage == 'fr' ? 'Autre' : 'Other',
                    color: '#ECECEC'

                })
                //Drawing pie chart
                chartConfig.series = [{
                    colorByPoint: true,
                    data: pieData,

                }];
                var percentOustandingShares = inovestor.ms.core.currentLanguage == 'fr' ? '% des actions en circulation' : '% of outstanding shares';
                chartConfig.subtitle = {
                    text: "Top 10 <br />" + Highcharts.numberFormat(topTenPercent, 2) + percentOustandingShares,
                    verticalAlign: "bottom",
                    y: -10
                },
                    pie.highcharts(chartConfig);
            }
        },

        //Bar Chart Rendering
        _renderBarChart: function () {
            var plugin = this;
            var sharesSum = 0;
            var shareHolders = plugin._viewModel.holdings().shareHolders
            var holdings = plugin._viewModel.holdings()
            if (plugin._viewModel.hasValidData()) {
                var chartConfigDesktop = plugin._getBarChartConfig();
                var chartConfigMobile = plugin._getBarChartConfig();
                var barData = [];
                var desktopBar = plugin.$element.find('.desktop-bar-chart');
                var mobileBar = plugin.$element.find('.mobile-bar-chart');
                var resultsThreshold = 20;
                var resultsToDisplay = shareHolders.length > resultsThreshold ? resultsThreshold : shareHolders.length;

                for (var i = 0; i < resultsToDisplay; i++) {
                    if (shareHolders[i].shareOutstandingPercent < 0.01)
                        continue
                    sharesSum += shareHolders[i].numberOfShares;
                    var percent = shareHolders[i].shareOutstandingPercent;
                    barData.push({
                        y: percent >= 0 ? percent : percent * -1, // handling of negative data sets
                        //formattedY: Highcharts.numberFormat(percent, 2) + ' %',
                        name: inovestor.ms.core.currentLanguage == 'fr' ? shareHolders[i].nameFr : shareHolders[i].nameEn
                    });
                }
                chartConfigDesktop.series = [{
                    colorByPoint: true,
                    data: barData
                }];
                chartConfigMobile.series = [{
                    colorByPoint: true,
                    data: barData
                }];
                chartConfigMobile.plotOptions = {
                    series: {
                        borderWidth: 0,
                        pointWidth: 5,
                        dataLabels: {
                            enabled: true,
                            format: '{point.y:.2f}%'
                        }
                    }
                },
                    desktopBar.highcharts(chartConfigDesktop);
                mobileBar.highcharts(chartConfigMobile);
            }
        },

        //Sync Legend on table rows
        _legendInTable: function () {
            var plugin = this;
            var colors = [];
            var slices = plugin.$element.find(".highcharts-tracker path");

            for (var slice = 0; slice < this.topShareholders; slice++) {
                colors.push(
                    $(slices[slice]).attr("fill")
                );
            };
            plugin._cachedTopColors = $.extend(true, [], colors);
        },

        //Color fa-squares in table
        _colorify: function () {
            var plugin = this;
            var squares = plugin.$element.find("span.fa-square")
            var mobileSquares = plugin.$element.find(".shareholdersMobile span.fa-square")
            for (var square = 0; square < this.topShareholders; square++) {
                color = plugin._cachedTopColors[square];
                $(squares[square]).css({ 'color': color });
                $(mobileSquares[square]).css({ 'color': color });
            }
        }
    });

    // JQuery Plugin wrapper
    $.fn.inoMsStockShareholders = function (options) {
        this.each(function () {
            if (!$.data(this, pluginName)) {
                // Store instance of plugin in "$.data"
                $.data(this, pluginName, new Plugin(this, options));
            }
        });

        // return plugin to support JQuery chaining
        return this;
    };

    // Default options for plugin
    $.fn.inoMsStockShareholders.defaults = {
        symbol: null,
        onError: null,
        onReady: null,
        templatePaths: {
            shareholders: null
        },
        //Bar Chart Config
        barChartConfig: {
            chart: {
                type: 'column',
                height: 400
            },
            title: {
                text: null
            },
            xAxis: {
                type: 'category'
            },
            yAxis: {
                title: {
                    text: null
                }

            },
            legend: {
                enabled: false
            },
            plotOptions: {
                series: {
                    borderWidth: 0,
                    pointWidth: 20,
                    dataLabels: {
                        enabled: true,
                        format: '{point.y:.2f}%'
                    }
                }
            },
            tooltip: {
                headerFormat: '<span style="font-size:11px">Funds</span><br>',
                pointFormatter: function () {
                    return inovestor.ms.core.stringFormat('<span style="color: {pointColor}">{pointName}</span>: <b>{pointValue}%</b> {ofTotal}<br/>',
                        {
                            pointColor: this.color,
                            pointName: this.name,
                            pointValue: Highcharts.numberFormat(this.y, 2),
                            ofTotal: inovestor.ms.core.currentLanguage === 'fr' ? 'du total' : 'of total'
                        });
                }
            }
        },
        //Pie Chart Config
        pieChartConfig: {
            chart: {
                height: 320,
                type: 'pie',
                marginTop: -0,
            },
            credits: {
                enabled: false
            },
            title: {
                text: null
            },
            //subtitle: {
            //    text: "Top 10",
            //    verticalAlign: "bottom",
            //    y: -10

            //},
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false
                    },
                    showInLegend: true,
                    size: 200
                }
            },
            tooltip: {
                headerFormat: '',
                pointFormatter: function () {
                    return inovestor.ms.core.stringFormat("<strong>{title}</strong><br/> {value}", { title: this.name, value: this.formattedY });
                }
            },
            legend: {
                enabled: false
            }
        }
    };


})(inovestor.ms.libRef.jQuery, inovestor.ms.libRef.ko, inovestor);
; (function (stock, undefined) {
    stock.shareholders.resources = stock.shareholders.resources || {};
    stock.shareholders.resources["en"] = {
        name: "Name",
        code: "Code",
        marketValue: "Market Value",
        marketPercent: "% Out.",
        numberOfShares: "# Shares",
        totalSharesHeld: "% Total Shares Held",
        shareholders: "Shareholders that own",
        sharesHeld: "% Shares Outstanding",
        fundsThatOwn: "Funds that own",
        percentNav: "(% shares outstanding)",
        next: "Next",
        previous:"Previous",
        dataNotAvailable: 'Data is not available'
    };
})(inovestor.ms.stock);

; (function (stock, undefined) {
    stock.shareholders.resources = stock.shareholders.resources || {};
    stock.shareholders.resources["fr"] = {
        name: "Libellé",
        code: "Code",
        marketValue: "Capitalisation",
        marketPercent: "% cap.",
        numberOfShares: "# Actions",
        totalSharesHeld: "% Total des actions détenues",
        shareholders: "Actionnaires",
        sharesHeld: "% Actions en circulations",
        fundsThatOwn: "Obligations détenues",
        percentNav: "(% Valeur liquidative)",
        next: "Suivant",
        previous: "Précédent",
        dataNotAvailable: 'Les données ne sont pas disponibles'
    };
})(inovestor.ms.stock);
